/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFAQ = {
  init() {
    const $faqHeading = $('.faq-accordion > dt > button');

    $('.faq-accordion > dd').attr('aria-hidden', true);

    $faqHeading.attr('aria-expanded', false);

    $faqHeading.off('click activate').on('click activate', function () {
      const $faqIcons = $(this).find('.icon');
      const $plus = $(this).find('.plus');
      const $state = $(this).attr('aria-expanded') === 'false';
      $plus.toggleClass('collapsed');
      $(this).attr('aria-expanded', $state);
      $(this).parent().next().slideToggle(() => {
        $faqIcons.toggleClass('icon--active');
      });
      $(this).parent().next().attr('aria-hidden', !$state);
      return false;
    });
  },
  unload() {
    $('.faq-accordion > dt > button').off('click activate');
    $('.faq-accordion > dt > button').off('keydown');
  },
};

/******/ })()
;